module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/level-1_start-94903c9cf11152555713aeb99ec77af8.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/level-1_start.png
// module id = 2270
// module chunks = 2